import __menu from "../../assets/img/archor-menu.svg"
import __html from "../../assets/img/html.svg"
import __header from "../../assets/img/header.svg"
import __canvas from "../../assets/img/canvas.svg"
import __merge from "../../assets/img/merge.svg"
import __image from "../../assets/img/picture.svg"
import __map from "../../assets/img/map.svg"
import __motivation from "../../assets/img/motivation.svg"
import __portfolio from "../../assets/img/portfolio.svg"
import __team from "../../assets/img/team.svg"
import __testanomials from "../../assets/img/testanomials.svg"
import __video from "../../assets/img/video.svg"
import __cards from "../../assets/img/card.svg"
import __widgets from "../../assets/img/widgets.svg"
import __zoompanpinch from "../../assets/img/zoompanpinch.svg"
import __shedules from "../../assets/img/shedules.svg"
import __contact_form from "../../assets/img/contact_form.svg"
import __matchings from "../../assets/img/matchings.svg"
import __design from "../../assets/img/section-growth.svg"
import __buttons from "../../assets/img/buttons.svg"
import __tabs from "../../assets/img/tabs.svg"
import __product from "../../assets/img/035-product.svg"
import __carousel from "../../assets/img/carousel.svg"
import __contacts from "../../assets/img/contacts.svg"
import __iframe from "../../assets/img/iframe.svg" 
import __logo from "../../assets/img/logo.svg" 
import __person from "../../assets/img/person.svg" 
import __dot_navidation from "../../assets/img/dot_navidation.svg" 
import __marriage from "../../assets/img/marriage.svg" 
import __table from "../../assets/img/table.svg" 
import __vernissage from "../../assets/img/vernissage.svg" 
import __passage from "../../assets/img/passage.svg" 
import __graphs from "../../assets/img/graphs.svg" 
import __icon from "../../assets/img/icon.svg" 
import __writer from "../../assets/img/writer.svg" 
import __modal from "../../assets/img/modal.svg" 
// import __inner_link from "../../assets/img/inner-link.svg"
// import __quote from "../../assets/img/quote.svg"
// import __calculator from "../../assets/img/calculator.svg"
// import __eventsFeed from "../../assets/img/events-feed.svg"
// import __postFeed from "../../assets/img/post-feed.svg"
// import __outer_link from "../../assets/img/outer-link.svg"
// import __button_animate_to from "../../assets/img/anchor.svg"
// import __likes from "../../assets/img/likes.svg"
// import __title from "../../assets/img/title.svg"
// import __description from "../../assets/img/description.svg"
// import __layers from "../../assets/img/layers.svg"
// import __rows from "../../assets/img/149-menu-1.svg"
// import __columns from "../../assets/img/150-menu-2.svg"
// import __accordeon from "../../assets/img/accordeon.svg"
// import __time_line from "../../assets/img/time_line.svg"
// import __sm from "../../assets/img/android.svg" 
// import __xs from "../../assets/img/android1.svg"

import { BUNCH, LANDING_TYPE_CONTENT } from "../interfaces"
import { HTML as _HTML } from "src/libs/interfaces/layouts"

import { Canvas,  Cards, 
	Features, 	HTML, 
	Image, Person, 
	Persons, PEWidget, 
	Testinomials, YandexMap, 
	Menu, Header, 
	Logo, ThumbnailTile,
	Table,
	VKVideo,
	Gallery,
	VKVideoPlayList,
	ZoomPanPinch,
	Shedules,
	ContactForm,
	Marriage,
	Vernissage,
	Buttons,
	Tabs,
	FBGoods,
	DotsNavigation,
	Contacts,
	DataContent,
	RandomContent,
	InfoGraphics,
	Icon,
	Passage,
	Writer,
	TwirlText,
	LinksFeed,
	Modal,
} from "../../views/landing/contentType" 
import { 
	HTMLPrimitive, 
	ImagePrimitive, 
	PersonPrimitive, 
	MenuPrimitive, 
	HeaderPrimitive, 
	YandexMapPrimitive,
	LogoPrimitive,
	ThumbnailTilePrimitive,
	TablePrimitive,
	VKVideoPrimitive, 
	GalleryPrimitive,
	VKVideoPlayListPrimitive,
	ZoomPanPinchPrimitive,
	CanvasPrimitive,
	ContactFormPrimitive,
	MarriagePrimitive,
	VernissagePrimitive,
	ButtonsPrimitive,
	TabsPrimitive, 
	DotsNavigationPrimitive,
	ContactsPrimitive,
	DataContentPrimitive,
	RandomContentPrimitive,
	IconPrimitive,
	InfoGraphiscPrimitive,
	WriterPrimitive,
	TwirlTextPrimitive,
	PassagePrimitive,
	LinksFeedPrimitive,
	ModalPrimitive,
} from "../../views/landing/primitive" 
import { moduleExists, modules } from "src/libs/layouts";    
import {
	cards,
	dots_navigation,
	html,
	image,
	personalCards,
	vernissage,
	marriage, 
	icon,
	person,
	table,
	thumbnail_tile,
	vk_video_playlist,
	infoGraphics,
	pe_widget,
	canvas,
	features_cards,
	testinomials,
	buttons,
	zoom_pan_pinch,
	tabs,
	ymap,
	logo,
	header,
	passage,
	shedules, 
	contacts,
	twirlText,
	writer,
	contact_form,
	random_content,
	modal
} from "../defaults";
import fb_goods from "./fb_goods"  


export interface ILandingComponentData {
    c: JSX.Element,
    icon: any
    title: _HTML | string
}
export interface ILandingComponent {
    [ key: LANDING_TYPE_CONTENT | string ] : any
}
export const components: ILandingComponent | any = () => {
	return {
		...getComponentsFromModules(),
		[ LANDING_TYPE_CONTENT.CANVAS ]: { 
			c: Canvas, 
			icon: __canvas, 
			title: "Empty canvas", 
			interface: "CanvasContent",
			primitive: CanvasPrimitive, 
			default: canvas(),
			bunch: BUNCH.LAYOUT,
		},
		[ LANDING_TYPE_CONTENT.HTML ]: { 
			c: HTML, 
			icon: __html, 
			title: "Simple HTML", 
			interface: "HTMLContent",
			primitive: HTMLPrimitive, 
			default: html(),
			bunch: BUNCH.TEXT,
		},
		[ LANDING_TYPE_CONTENT.WRITER ]: { 
			c: Writer, 
			icon: __writer, 
			title: "Writer",
			interface: "WriterContent",  
			primitive: WriterPrimitive, 
			default: writer() ,
			bunch: BUNCH.TEXT,
		},
		[ LANDING_TYPE_CONTENT.TWIRL_TEXT ]: { 
			c: TwirlText, 
			icon: __writer, 
			title: "Twirl Text",
			interface: "TwirlTextContent",  
			primitive: TwirlTextPrimitive, 
			default: twirlText() ,
			bunch: BUNCH.TEXT,
		},
		[ LANDING_TYPE_CONTENT.IMAGE ]: { 
			c: Image, 
			icon: __image, 
			title: "Image", 
			interface: "ImageContent", 
			primitive: ImagePrimitive, 
			default: image(),
			bunch: BUNCH.IMAGES,
		},
		[ LANDING_TYPE_CONTENT.THUMBNAIL_TILE ]: { 
			c: ThumbnailTile, 
			icon: __merge, title: 
			"Thumbnails tile", 
			interface: "ThumbnailTileContent", 
			primitive: ThumbnailTilePrimitive, 
			default: thumbnail_tile(),
			bunch: BUNCH.GALLERIES,
		},
		[ LANDING_TYPE_CONTENT.MARRIAGE ]: { 
			c: Marriage, icon: __marriage, 
			title: "Marriage", 
			interface: "MarriageContent",  
			primitive: MarriagePrimitive,
			default: marriage(),
			bunch: BUNCH.GALLERIES,
		},
		[ LANDING_TYPE_CONTENT.VERNISSAGE ]: { 
			c: Vernissage, 
			icon: __vernissage, 
			title: "Vernissage", 
			interface: "ContactFormContent", 
			primitive: VernissagePrimitive, 
			default: vernissage(),
			bunch: BUNCH.GALLERIES,
		},
		[ LANDING_TYPE_CONTENT.PASSAGE ]: { 
			c: Passage, 
			icon: __passage, 
			title: "Passage",
			interface: "PassageContent",  
			primitive: PassagePrimitive, 
			default: passage(),
			bunch: BUNCH.GALLERIES,
		},
		[ LANDING_TYPE_CONTENT.ICON ]: { 
			c: Icon, 
			icon: __icon, 
			title: "Icon", 
			interface: "IconContent", 
			primitive: IconPrimitive, 
			default: icon(),
			bunch: BUNCH.IMAGES,
		},
		[ LANDING_TYPE_CONTENT.WIDGET ]: { 
			c: PEWidget, 
			icon: __widgets,
			title: "PE Widget",
			interface: "WidgetContent", 
			primitive: ImagePrimitive, 
			default: pe_widget(),
			bunch: BUNCH.WIDGETS,
		},
		[ LANDING_TYPE_CONTENT.CARDS ]: { 
			c: Cards, 
			icon: __cards, 
			title: "Cards", 
			interface: "CardsContent", 
			primitive: ImagePrimitive, 
			default: cards(),
			bunch: BUNCH.CARDS,
		},
		[ LANDING_TYPE_CONTENT.FEATURES_CARDS ]: { 
			c: Features, 
			icon: __motivation, 
			title: "Features", 
			interface: "FeaturesContent", 
			primitive: ImagePrimitive, 
			default: features_cards(),
			bunch: BUNCH.FEATURES_CARDS,
		},
		[ LANDING_TYPE_CONTENT.PERSON ]: { 
			c: Person, 
			icon: __person, 
			title: "Person",
			interface: "PersonContent",  
			primitive: PersonPrimitive, 
			default: person(),
			bunch: BUNCH.PERSON, 
		},
		[ LANDING_TYPE_CONTENT.PERSONAL_CARDS ]: { 
			c: Persons, 
			icon: __team, 
			title: "Team", 
			interface: "PersonsContent", 
			primitive: ImagePrimitive, 
			default: personalCards(),
			bunch: BUNCH.TEAM,
		},
		[ LANDING_TYPE_CONTENT.TESTINOMIALS ]: { 
			c: Testinomials, 
			icon: __testanomials, 
			interface: "TestinomialContent", 
			title: "Testinomials", 
			default: testinomials(),
			bunch: BUNCH.TESTINOMIALS,
		},
		[ LANDING_TYPE_CONTENT.YANDEX_MAP ]: { 
			c: YandexMap, 
			icon: __map, 
			title: "Yandex Map", 
			interface: "YamapContent", 
			primitive: YandexMapPrimitive, 
			default: ymap(),
			bunch: BUNCH.MAPS,
		},
		[ LANDING_TYPE_CONTENT.HEADER ]: { 
			c: Header, 
			icon: __header, 
			title: "Smart menu", 
			interface: "HeaderContent", 
			primitive: MenuPrimitive, 
			default: header(),
			bunch: BUNCH.HEADERS,
		},
		[ LANDING_TYPE_CONTENT.MENU ]: { c: Menu, icon: __menu, title: "Page menu header", interface: "MenuContent", primitive: HeaderPrimitive, bunch: BUNCH.HEADERS,},
		[ LANDING_TYPE_CONTENT.LOGO ]: { 
			c: Logo, 
			icon: __logo, 
			title: "Logotype", 
			interface: "LogoContent", 
			primitive: LogoPrimitive, 
			default: logo(),
			bunch: BUNCH.HEADERS,
		},
		[ LANDING_TYPE_CONTENT.TABLE ]: { 
			c: Table, 
			icon: __table, 
			title: "Table", 
			interface: "TableContent", 
			primitive: TablePrimitive, 
			default: table(),
			bunch: BUNCH.TABLES,
		},
		[ LANDING_TYPE_CONTENT.VK_VIDEO ]: { c: VKVideo, icon: __video, title: "VK Video", interface: "VKVideoContent", primitive: VKVideoPrimitive, bunch: BUNCH.VIDEO,},
		[ LANDING_TYPE_CONTENT.VK_VIDEO_PLAYLIST ]: { 
			c: VKVideoPlayList, 
			icon: __video, 
			title: "VK Video Playlist", 
			interface: "VKVideoPlaylistContent",  
			primitive: VKVideoPlayListPrimitive, 
			default: vk_video_playlist(),
			bunch: BUNCH.VIDEO,
		},
		[ LANDING_TYPE_CONTENT.GALLERY ]: { 
			c: Gallery, 
			icon: __carousel, 
			title: "Image gallery", 
			interface: "GalleryContent", 
			primitive: GalleryPrimitive,
			bunch: BUNCH.GALLERIES, 
		},
		[ LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH ]: { 
			c: ZoomPanPinch, 
			icon: __zoompanpinch, 
			title: "Zoom-pan-pinch", 
			interface: "ZoomPanPinchContent", 
			primitive: ZoomPanPinchPrimitive, 
			default: zoom_pan_pinch() ,
			bunch: BUNCH.IMAGES,
		},
		[ LANDING_TYPE_CONTENT.SHEDULE_CARDS ]: { 
			c: Shedules, 
			icon: __shedules, 
			interface: "ShedulesContent",  
			title: "Shedules", 
			default: shedules(),
			bunch: BUNCH.SHEDULE_CARDS,
		},
		[ LANDING_TYPE_CONTENT.CONTACT_FORM ]: { 
			c: ContactForm, 
			icon: __contact_form, 
			default: contact_form(),
			title: "Contact form", 
			interface: "ContactFormContent", 
			primitive: ContactFormPrimitive,
			bunch: BUNCH.CONTACT_FORMS,
		},
		[ LANDING_TYPE_CONTENT.BUTTONS ]: { 
			c: Buttons, 
			icon: __buttons, 
			title: "Buttons", 
			interface: "ButtonsContent", 
			primitive: ButtonsPrimitive, 
			default: buttons() ,
			bunch: BUNCH.BUTTONS,
		},
		[ LANDING_TYPE_CONTENT.TABS ]: { 
			c: Tabs, 
			icon: __tabs, 
			title: "Tabs", 
			interface: "TabsContent", 
			primitive: TabsPrimitive, 
			default: tabs(), 
			bunch: BUNCH.WIDGETS,
		},
		[ LANDING_TYPE_CONTENT.DOTS_NAVIGATION ]: { 
			c: DotsNavigation, 
			icon: __dot_navidation, 
			title: "Dots Navigation", 
			interface: "DotsNavigationContent", 
			primitive: DotsNavigationPrimitive, 
			default: dots_navigation() ,
			bunch: BUNCH.HEADERS, 
		},
		[ LANDING_TYPE_CONTENT.FB_GOODS ]: { c: FBGoods, icon: __product, interface: "FBGoodsContent", title: "Structured cards", 
			bunch: BUNCH.CARDS,},
		[ LANDING_TYPE_CONTENT.CONTACTS ]: { 
			c: Contacts, 
			icon: __contacts, 
			title: "Contacts list", 
			interface: "ContactsContent", 
			primitive: ContactsPrimitive, 
			default: contacts()  ,
			bunch: BUNCH.BUTTONS,
		},
		[ LANDING_TYPE_CONTENT.DATA_CONTENT ]: { 
			c: DataContent, 
			icon: __iframe,
			title: "Meats",
			interface: "DataContentContent",  
			primitive: DataContentPrimitive, 
			bunch: BUNCH.LAYOUT,
		},
		[ LANDING_TYPE_CONTENT.RANDOM_CONTENT ]: { 
			c: RandomContent, 
			icon: __iframe,
			title: "Random",
			interface: "RandomContentContent",  
			primitive: RandomContentPrimitive, 
			default: random_content(),
			bunch: BUNCH.LAYOUT,
		},
		[ LANDING_TYPE_CONTENT.INFO_GRAPHICS ]: { 
			c: InfoGraphics, 
			icon: __graphs, 
			title: "Info graphics",
			interface: "InfoGraphiscContent",  
			primitive: InfoGraphiscPrimitive, 
			default: infoGraphics() ,
			bunch: BUNCH.INFO_GRAPHICS,
		},
		[ LANDING_TYPE_CONTENT.LINKS_FEED ]: { 
			c: LinksFeed, 
			icon: __iframe, 
			title: "Links Feed",
			interface: "LinksFeedContent",  
			primitive: LinksFeedPrimitive, 
			default: infoGraphics() ,
			bunch: BUNCH.LAYOUT,
		},
		[ LANDING_TYPE_CONTENT.MODAL ]: { 
			c: Modal, 
			icon: __modal, 
			title: "Modal",
			interface: "ModalContent",  
			primitive: ModalPrimitive, 
			default: modal() ,
			bunch: BUNCH.OVERLAY,
		},

 
		// carousel: { c: Carousel, icon: __carousel, title: "Carousel" },
		// layers: { c: Layers, icon: __layers, title: "Layers" },
		// rows: { c: Rows, icon: __rows, title: "Rows" },
		// columns: { c: Columns, icon: __columns, title: "Columns" },
		// mask: { c: Mask, icon: __image, title: "Mask" },
		// inner_link: { c: InnerLink, icon: __inner_link, title: "Inner Link" },
		// outer_url: { c: OuterURL, icon: __outer_link, title: "Outer URL" },
		// button_animate_to: { c: ButtonAnimateTo, icon: __button_animate_to, title: "Buttom to Archor" },
		// team: { c: Team, icon: __team, title: "Team" },
		// quote: { c: Quote, icon: __quote, title: "Quote" },
		// social_likes: { c: SocialLikes, icon: __likes, title: "Social Likes" },
		// video_play_list: { c: VideoPlayList, icon: __video, title: "Video Play List" },
		// video: { c: Video, icon: __video, title: "Video" },
		// post_feed: { c: PostFeed, icon: __postFeed, title: "Feed" },
		// post_carousel: { c: PostCarousel, icon: __carousel, title: "Post carousel" },
		// matchings: { c: Matchings, icon: __matchings, title: "Matchings" },
		// 
		// magic_grass: { c: MagicGlass, icon: __zoompanpinch, title: "Magic Glass" },
		// accordeon: { c: Accordeon, icon: __accordeon, title: "Accordeon" },
		// haccordeon: { c: Haccordeon, icon: __accordeon, title: "Horisontal animated accordeon" },
		// time_line: { c: TimeLine, icon: __time_line, title: "Time Line" },
		// vk: { c: VKWidget, icon: __time_line, title: "VKontakte" },
		// iframe: { c: IFrame, icon: __iframe, title: "IFrame" },
		// include_section: { c: IncludeSection, icon: __quote, title: "Include Section" },
		// tabs: { c: Tabs, icon: __tabs, title: "Tabs" },

		// KraevedTitle: { c: KraevedTitle, icon: __kraeved, title: "Kraeved Title" },
		// KraevedTitle2: { c: KraevedTitle2, icon: __kraeved, title: "Kraeved Title 2" },
		// KraevedVideoPlayList: { c: KraevedVideoPlayList, icon: __video, title: "Kraeved Content Video Player" },
		
		// ...getExtendsComponents()
	}
}


const getComponentsFromModules = (): any => {
	let landingComponents: any = {}
	Object.keys(modules()).forEach(module => {
		if(moduleExists(module) && module === "pe-tests-module") {
			try{
				const { landingComponent } = require( `src/modules/${module}/data/utils/landingComponent` ) 
				if(landingComponent) {
					landingComponents = { ...landingComponents, ...landingComponent() }
				}
			} catch( e: any ) {
				console.error( e )
			 } 
		}
	})
	return landingComponents 
}
 